import { combineReducers } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import uiShellReducer from './uiShellSlice'
import { baseApi } from '../features/api/baseApi'
import '../features/api/authEndpoints'
import '../features/api/playersApi'
import '../features/api/walletApi'
import '../features/api/dashboardApi'
import '../features/api/tablesApi'
import '../features/api/tournamentsApi'
import '../features/api/promotionsApi'
import '../features/api/supportApi'
import '../features/api/reportsApi'
import '../features/api/settingsApi'
import '../features/api/missingDomainAdapters'

export default combineReducers({
  auth: authReducer,
  uiShell: uiShellReducer,
  [baseApi.reducerPath]: baseApi.reducer,
})
